import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import ruralPropertyListAction from './ruralPropertyList.action.json' assert { type: 'json' }
import { ruralPropertyObject } from '../ruralPropertyObject'

export const ruralPropertyExpression = expression(ruralPropertyObject.shape)

const ruralPropertyListDefinition = defineAction({
  ...ruralPropertyListAction,

  input: z.object({
    filter: ruralPropertyExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      residenceId: 'Residência',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(ruralPropertyObject),
    count: z.number(),
  }),
})

export default ruralPropertyListDefinition
